import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/components/Footer.css';
import { translations } from '../translations';
import { useFont } from '../contexts/FontContext';

function Footer({ language, setLanguage }) {
  const t = translations[language];
  const { fontType, setFontType } = useFont();
  
  const toggleLanguage = () => {
    const languages = ['en', 'fr', 'tr'];
    const currentIndex = languages.indexOf(language);
    const nextIndex = (currentIndex + 1) % languages.length;
    setLanguage(languages[nextIndex]);
  };

  const handleFontChange = (event) => {
    setFontType(event.target.value);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-wrapper">
          <div className="footer-content">
            <div className="footer-section">
              <h3 className="footer-title">{t.company}</h3>
              <ul className="footer-links">
                <li>
                  <Link to="/about" className="footer-link">
                    {t.about}
                  </Link>
                </li>
                <li>
                  <Link to="/features" className="footer-link">
                    {t.features}
                  </Link>
                </li>
                <li>
                  <Link to="/reviews" className="footer-link">
                    {t.reviewsTitle || 'Reviews'}
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="footer-link">
                    {t.contact}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h3 className="footer-title">{t.legal}</h3>
              <ul className="footer-links">
                <li>
                  <Link to="/privacy" className="footer-link">
                    {t.privacy}
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="footer-link">
                    {t.terms}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h3 className="footer-title">{t.contact}</h3>
              <ul className="footer-links">
                <li>
                  <a href="mailto:support@dysorto.fr" className="footer-link">
                    support@dysorto.fr
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-divider"></div>
          <div className="store-buttons">
            {/* <a href="#" className="store-button app-store" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z" />
              </svg>
              <span>Download on App Store</span>
            </a> */}
            <a href="https://play.google.com/store/apps/details?id=com.DysOrtoInnovations.DysOrto" className="store-button google-play" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
              </svg>
              <span>Get it on Google Play</span>
            </a>
          </div>
        </div>
        <hr className="footer-bottom-divider" />
        <div className="footer-bottom">
          <p className="copyright">
            2026 DysOrto. {t.rightsReserved}
          </p>
          <div className="footer-bottom-right">
            <div className="font-selector">
              <select 
                value={fontType}
                onChange={handleFontChange}
                className="font-select"
              >
                <option value="sans-serif">Normal Font</option>
                <option value="ortho">Ortho Font</option>
              </select>
            </div>
            {/* <div className="social-links">
              <a href="#" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96A10 10 0 0 0 22 12.06C22 6.53 17.5 2.04 12 2.04Z" />
                </svg>
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M6.88 8.56A1.68 1.68 0 0 0 8.56 6.88C8.56 5.95 7.81 5.19 6.88 5.19A1.69 1.69 0 0 0 5.19 6.88C5.19 7.81 5.95 8.56 6.88 8.56M8.27 18.5V10.13H5.5V18.5H8.27Z" />
                </svg>
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H19M18.5 18.5V13.2A3.26 3.26 0 0 0 15.24 9.94C14.39 9.94 13.4 10.46 12.92 11.24V10.13H10.13V18.5H12.92V13.57C12.92 12.8 13.54 12.17 14.31 12.17A1.4 1.4 0 0 1 15.71 13.57V18.5H18.5M6.88 8.56A1.68 1.68 0 0 0 8.56 6.88C8.56 5.95 7.81 5.19 6.88 5.19A1.69 1.69 0 0 0 5.19 6.88C5.19 7.81 5.95 8.56 6.88 8.56M8.27 18.5V10.13H5.5V18.5H8.27Z" />
                </svg>
              </a>
            </div> */}
            <button onClick={toggleLanguage} className="language-switch">
              {language === 'en' && (
                <>
                  <svg className="flag-icon" viewBox="0 0 24 24">
                    <path fill="#ED2939" d="M4 4h16v16H4z"/>
                    <path fill="#FFFFFF" d="M4 4h10.667v16H4z"/>
                    <path fill="#002395" d="M4 4h5.333v16H4z"/>
                  </svg>
                  FR
                </>
              )}
              {language === 'fr' && (
                <>
                  <svg className="flag-icon" viewBox="0 0 24 24">
                    <rect width="24" height="24" fill="#E30A17"/>
                    <circle cx="10" cy="12" r="5" fill="#FFFFFF"/>
                    <circle cx="11.5" cy="12" r="4" fill="#E30A17"/>
                    <polygon fill="#FFFFFF" points="13,12 15,10.5 14,12 15,13.5" />
                  </svg>
                  TR
                </>
              )}
              {language === 'tr' && (
                <>
                  <svg className="flag-icon" viewBox="0 0 24 24">
                    <rect width="24" height="24" fill="#FFFFFF"/>
                    <rect width="24" height="1.85" y="0" fill="#B31942"/>
                    <rect width="24" height="1.85" y="3.7" fill="#B31942"/>
                    <rect width="24" height="1.85" y="7.4" fill="#B31942"/>
                    <rect width="24" height="1.85" y="11.1" fill="#B31942"/>
                    <rect width="24" height="1.85" y="14.8" fill="#B31942"/>
                    <rect width="24" height="1.85" y="18.5" fill="#B31942"/>
                    <rect width="24" height="1.85" y="22.2" fill="#B31942"/>
                    <rect width="10" height="12.95" fill="#002868"/>
                  </svg>
                  EN
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
